<template>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <div v-if="riskSurveyMode === 'Query'">
                <v-icon>mdi-magnify</v-icon>
              </div>
              <div v-if="riskSurveyMode === 'Review'">
                <v-icon>mdi-pencil</v-icon>
              </div>
              <div v-if="riskSurveyMode === 'New'">
                <v-icon>mdi-plus</v-icon>
              </div>
              <v-toolbar-title v-if="riskSurveyMode !== 'New'"  class="toolbar-title-2">{{ riskSurveyMaster.survNo }} / {{ riskSurveyMaster.verCnt }} {{ riskSurveyMaster.insdName === undefined ? '' : ' - ' + riskSurveyMaster.insdName }}</v-toolbar-title>
              <v-toolbar-title v-else class="toolbar-title-2">New Risk Survey</v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="riskSurveyTabs">
              <v-tab @click.native="doTab(0)">Header</v-tab>
              <v-tab @click.native="doTab(1)" :disabled="doDisabledTab">Construction</v-tab>
              <v-tab @click.native="doTab(2)" :disabled="doDisabledTab">Surroundings</v-tab>
              <v-tab @click.native="doTab(3)" :disabled="doDisabledTab">Lighting</v-tab>
              <v-tab @click.native="doTab(4)" :disabled="doDisabledTab">Fire Prevention</v-tab>
              <v-tab @click.native="doTab(5)" :disabled="doDisabledTab">Management</v-tab>
              <v-tab @click.native="doTab(6)" :disabled="doDisabledTab">Interest Insured</v-tab>
              <v-tab @click.native="doTab(7)" :disabled="doDisabledTab">Occupation</v-tab>
              <v-tab @click.native="doTab(8)" :disabled="doDisabledTab">Fire Attachment</v-tab>
              <v-tab @click.native="doTab(9)" :disabled="doDisabledTab">Stock Description</v-tab>
              <v-tab @click.native="doTab(10)" :disabled="doDisabledTab">Premises Description</v-tab>
              <v-tab @click.native="doTab(11)" :disabled="doDisabledTab">Entrance</v-tab>
              <v-tab @click.native="doTab(12)" :disabled="doDisabledTab">Safe Room</v-tab>
              <v-tab @click.native="doTab(13)" :disabled="doDisabledTab">Burglary Attachment</v-tab>
            </v-tabs>
            <v-layout row wrap>
              <v-flex xs12>
                <RiskSurveyHeader v-if="tabNav === 0"></RiskSurveyHeader>
                <RiskSurveyConstruction v-if="tabNav === 1"></RiskSurveyConstruction>
                <RiskSurveySurroundings v-if="tabNav === 2"></RiskSurveySurroundings>
                <RiskSurveyLighting v-if="tabNav === 3"></RiskSurveyLighting>
                <RiskSurveyFirePrevent v-if="tabNav === 4"></RiskSurveyFirePrevent>
                <RiskSurveyManagement v-if="tabNav === 5"></RiskSurveyManagement>
                <RiskSurveyInterestInsd v-if="tabNav === 6"></RiskSurveyInterestInsd>
                <RiskSurveyOccupation v-if="tabNav === 7"></RiskSurveyOccupation>
                <RiskSurveyFireAttch v-if="tabNav === 8"></RiskSurveyFireAttch>
                <RiskSurveyStockDesc v-if="tabNav === 9"></RiskSurveyStockDesc>
                <RiskSurveyPremisesDesc v-if="tabNav === 10"></RiskSurveyPremisesDesc>
                <RiskSurveyEntrance v-if="tabNav === 11"></RiskSurveyEntrance>
                <RiskSurveySafeRoom v-if="tabNav === 12"></RiskSurveySafeRoom>
                <RiskSurveyBurglaryAttch v-if="tabNav === 13"></RiskSurveyBurglaryAttch>
              </v-flex>
            </v-layout>
            <v-flex xs12>
            <v-btn color="error" dark @click.prevent="doExit">
              {{actionLabel.exit}}
              <v-icon dark right>mdi-exit-to-app</v-icon>
            </v-btn>
          </v-flex>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog v-model="showErrorDialog" width="800px" >
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when creating Credit Note.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{error.message}}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { RISK_SURVEY_TAB } from '@/store/types'
import RiskSurveyHeader from '@/components/core/underwriting/specialFuncUW/riskSurvey/RiskSurveyHeader'
import RiskSurveyConstruction from '@/components/core/underwriting/specialFuncUW/riskSurvey//RiskSurveyConstruction'
import RiskSurveySurroundings from '@/components/core/underwriting/specialFuncUW/riskSurvey//RiskSurveySurroundings'
import RiskSurveyLighting from '@/components/core/underwriting/specialFuncUW/riskSurvey//RiskSurveyLighting'
import RiskSurveyFirePrevent from '@/components/core/underwriting/specialFuncUW/riskSurvey/RiskSurveyFirePrevent'
import RiskSurveyManagement from '@/components/core/underwriting/specialFuncUW/riskSurvey/RiskSurveyManagement'
import RiskSurveyInterestInsd from '@/components/core/underwriting/specialFuncUW/riskSurvey/RiskSurveyInterestInsd'
import RiskSurveyOccupation from '@/components/core/underwriting/specialFuncUW/riskSurvey/RiskSurveyOccupation'
import RiskSurveyFireAttch from '@/components/core/underwriting/specialFuncUW/riskSurvey/RiskSurveyFireAttch'
import RiskSurveyStockDesc from '@/components/core/underwriting/specialFuncUW/riskSurvey/RiskSurveyStockDesc'
import RiskSurveyEntrance from '@/components/core/underwriting/specialFuncUW/riskSurvey/RiskSurveyEntrance'
import RiskSurveySafeRoom from '@/components/core/underwriting/specialFuncUW/riskSurvey/RiskSurveySafeRoom'
import RiskSurveyPremisesDesc from '@/components/core/underwriting/specialFuncUW/riskSurvey/RiskSurveyPremisesDesc'
import RiskSurveyBurglaryAttch from '@/components/core/underwriting/specialFuncUW/riskSurvey/RiskSurveyBurglaryAttch'

export default {
  data() {
    return {
      actionLabel: {
        exit: 'Exit',
        reset: 'Reset',
        save: 'Save'
      },
      formParam: undefined,
      survDetForm: {},
      loading: false,
      showErrorDialog: false,
      submitting: false,
      showPromptLeave: true,
      riskSurveys: 0,
      riskSurveyTabs: 0,
      riskSurveyApiUrl: '',
      survNoParam: null,
      tabNav: 0
    }
  },
  watch: {
    'displayErrorDialog': {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    'riskSurveyTab': function (value) {
      this.riskSurveys = value
      this.riskSurveyTabs = this.riskSurveyTab
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyTab() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyTab
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    doDisabledTab() {
      return this.riskSurveyMode === 'New'
    }
  },
  methods: {
    doInit() {
      this.$store.commit(RISK_SURVEY_TAB, 0)
      this.riskSurveys = this.riskSurveyTab
      this.riskSurveyTabs = this.riskSurveyTab
      this.survNoParam = this.riskSurveyMaster.survNo
    },
    doExit() {
      this.$store.commit(RISK_SURVEY_TAB, 0)
      this.$emit('close')
    },
    async doTab(tab) {
      if (!this.doDisabledTab) {
        this.resetMessages()
        this.tabNav = tab
        this.$store.commit(RISK_SURVEY_TAB, this.tabNav)
      }
    }
  },
  created() {
  },
  beforeMount() {
  },
  mixins: [
    MessageMixin
  ],
  components: {
    RiskSurveyHeader,
    RiskSurveyConstruction,
    RiskSurveySurroundings,
    RiskSurveyLighting,
    RiskSurveyFirePrevent,
    RiskSurveyManagement,
    RiskSurveyInterestInsd,
    RiskSurveyOccupation,
    RiskSurveyFireAttch,
    RiskSurveyStockDesc,
    RiskSurveyEntrance,
    RiskSurveySafeRoom,
    RiskSurveyBurglaryAttch,
    RiskSurveyPremisesDesc
  }
}
</script>
<style lang="scss">
@import "../../../../../assets/scss/accounting.scss";
</style>
